module.exports = __webpack_public_path__ + "img/logout_icon.6dbd1167.svg";